import axios from "axios";
import { BASE_URL_API } from "constants/base-url-api";

interface DataProp {
  hotelId: number;
  roomId: number[];
  token: string;
  checkInDate: string;
  authToken: string;
}

export const fetchBookingConditions = async (data: DataProp) => {
  const base = axios.create({
    baseURL: BASE_URL_API,
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${data.authToken}`,
    },
  });

  if (data.authToken) {
    const response = await base.post("/bookings/conditions", {
      hotel_id: data.hotelId,
      room_ids: data.roomId,
      token: data.token,
      check_in_date: data.checkInDate,
    });

    return response.data;
  }
}; 